import Select, { SelectProps } from "@/shared/form/select";
import { useDynamicEnumsForSelect } from "./model/use-dynamic-enums-for-select";

export function EnumSelect(props: SelectProps) {
  const { loading, options } = useDynamicEnumsForSelect();

  return <Select allowClear options={options} loading={loading} {...props} />;
}
